/**
 * ボイラ製品ラインアップ比較表グラフ表示
 */
export default function initProductBoilerMaping() {
  const root = document.querySelector(".p-product-boiler-maping");
  if (!root) return;

  const ranges = root.querySelectorAll(".p-product-boiler-maping__range");
  if (!ranges.length) return;

  const revealBar = (range) => {
    const graphWrap = range.querySelector(".p-product-boiler-maping__bar-wrap");
    if (graphWrap) {
      graphWrap.classList.add("is-bar-visible");
    }
  };

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          revealBar(entry.target);
          observer.unobserve(entry.target);
        }
      });
    },
    {
      root: null,
      rootMargin: "0px 0px -15% 0px",
      threshold: 0,
    }
  );

  ranges.forEach((range) => {
    observer.observe(range);
  });
}
